import React from 'react';
import PropTypes from 'prop-types';
import { useReporter } from '../../reporter';
import { ResponsiveImage } from '../ResponsiveImage';
import { CtaButton } from '../CtaButton';
import { BoxedCountdownClock } from '../BoxedCountdownClock';
import { orientationSettings } from './constants';
import { heroButtonClicked } from './events';
import {
  StyledHero,
  BackgroundImage,
  ContentContainer,
  Content,
  Header,
  Subheader,
  ButtonWrapper,
  CountdownAndLink,
} from './styles.js';

export const Hero = ({
  headline,
  subheadline,
  link,
  image,
  backgroundColor = 'background.base',
  fontColor = 'text.primary',
  horizontalOrientation = 'left',
  buttonVariant,
  targetDate = null,
}) => {
  const reporter = useReporter();

  return (
    <StyledHero backgroundColor={backgroundColor}>
      {/* $ is to prevent `srcSet` from being forward to the DOM */}
      <BackgroundImage image={image}>
        <ResponsiveImage
          {...image}
          priority
          layout={!image.picture ? 'responsive' : undefined}
          objectFit={image.picture ? 'cover' : undefined}
        />
      </BackgroundImage>
      <ContentContainer
        image={image}
        horizontalOrientation={orientationSettings[horizontalOrientation]}
      >
        <Content
          horizontalOrientation={orientationSettings[horizontalOrientation]}
        >
          {headline && <Header fontColor={fontColor}>{headline}</Header>}
          {subheadline && (
            <Subheader fontColor={fontColor}>{subheadline}</Subheader>
          )}
          {(targetDate || link) && (
            <CountdownAndLink>
              {targetDate && (
                <BoxedCountdownClock
                  targetDate={targetDate}
                  textColor={fontColor}
                />
              )}
              {link && (
                <ButtonWrapper>
                  <CtaButton
                    href={link.target}
                    variant={buttonVariant}
                    onClick={() =>
                      reporter.tag(heroButtonClicked(link.text, link.target))
                    }
                  >
                    {link.text}
                  </CtaButton>
                </ButtonWrapper>
              )}
            </CountdownAndLink>
          )}
        </Content>
      </ContentContainer>
    </StyledHero>
  );
};

Hero.displayName = 'Hero';

Hero.propTypes = {
  headline: PropTypes.node,
  subheadline: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }),
  backgroundColor: PropTypes.string,
  fontColor: PropTypes.string,
  image: PropTypes.object.isRequired,
  horizontalOrientation: PropTypes.oneOf(['left', 'center', 'right']),
  buttonVariant: PropTypes.string,
  targetDate: PropTypes.instanceOf(Date), //eslint-disable-line react/forbid-prop-types,
};
